export function  isErrorApi(error:any, statusCode:string){
  try{
    const status = error.response.data.message
    return status == statusCode
  }catch{
    return false
  }
}